"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var LinearProgress_1 = __importStar(require("@mui/material/LinearProgress"));
var styles_1 = require("@mui/material/styles");
/**
 * Edit the default Linear Bar to have a light background
 */
var BorderLinearProgress = (0, styles_1.styled)(LinearProgress_1.default)(function (_a) {
    var _b;
    var theme = _a.theme, classes = _a.classes;
    return (_b = {
            height: 8,
            borderRadius: 5
        },
        _b["&.".concat(LinearProgress_1.linearProgressClasses.colorPrimary)] = {
            backgroundColor: "".concat(theme.palette.secondary.light, "!important"),
        },
        _b["&.".concat(LinearProgress_1.linearProgressClasses.barColorPrimary)] = {
            backgroundColor: (classes === null || classes === void 0 ? void 0 : classes.bar) === 'success'
                ? "".concat(theme.palette.success.dark, "!important")
                : "".concat(theme.palette.error.dark, "!important"),
        },
        _b["& .".concat(LinearProgress_1.linearProgressClasses.bar)] = {
            borderRadius: 5,
            backgroundColor: (classes === null || classes === void 0 ? void 0 : classes.bar) === 'success'
                ? "".concat(theme.palette.success.dark, "!important")
                : "".concat(theme.palette.error.dark, "!important"),
        },
        _b);
});
exports.default = BorderLinearProgress;
//# sourceMappingURL=BorderLinearProgress.js.map